import { z } from 'zod';

import { Pagination } from '../common';
import { GovernanceEntityWcg } from '../common/governance-entity';

const GetPoliciesRequestSchema = z.object({
  'id-in': z.string().optional(),
  limit: z.string().optional(),
  offset: z.string().optional(),
  'sort-by': z.string().optional(),
  'sort-order': z.string().optional(),
  env: z.string().optional(),
  text: z.string().optional(),
  context: z.string().optional(),
  status: z.string().optional(),
  strategy: z.string().optional(),
  engine: z.string().optional(),
  'resource-type': z.string().optional(),
  severity: z.string().optional(),
  timing: z.string().optional(),
  trigger: z.string().optional(),
});

export type GetPoliciesRequest = z.infer<typeof GetPoliciesRequestSchema>;

export type GetPoliciesResponse = {
  data: GovernanceEntityWcg[];
  meta: {
    pagination: Pagination & { total: number };
  };
};
